import * as $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min.js';

export default (function () {
    $('.start-date').datepicker();
    $('.end-date').datepicker();

    $('.input-daterange-day').datepicker({
        format: "dd/mm/yyyy",
        todayBtn: "linked",
        autoclose: true,
        todayHighlight: true,
        language: "es",
        autoclose: true,
    });

    $('.input-daterange-month').datepicker({
        format: "mm/yyyy",
        weekStart: 1,
        minViewMode: 1,
        autoclose: true,
        todayHighlight: true,
        todayBtn: "linked",
        clearBtn: true,
        language: "es",
        autoclose: true,
        beforeShowDay: function (date) {
            if (date.getMonth() == (new Date()).getMonth()) {}
        }
    });


}())
